module.exports = __webpack_public_path__ + "img/animate-3-3.76101314.png";